module.exports = __webpack_public_path__ + "static/media/YF99_4.e13e8d4c.jpg";